import React from "react";
import { useSlideEnterAnimation } from "@hooks/useSlideEnterAnimation";
import { CTASection, EmailMarketingSection, CarouselLarge } from "@components/shared";
import { ExploreMangomint } from "@components/shared/exploreMangomint";
import {
  LpBlockquoteSection,
  LpFaqSection,
  LpLogoSoupSection,
  LpOneColSection,
  LpThreeColSection,
  LpTwoColSection,
  LpAtAGlance,
} from "@components/shared/landingPage";

export const getSectionComponent = ({ id, __typename, className, ...props }) => {
  switch (__typename) {
    case "ContentfulLandingPageSectionLogoSoup":
      return <LpLogoSoupSection className={className?.logoSoup} key={id} {...props} />;
    case "ContentfulLandingPageSectionAtAGlance":
      return <LpAtAGlance className={className?.atAGlance} key={id} {...props} />;
    case "ContentfulLandingPageSection1Column1Image":
      return <LpOneColSection className={className?.oneColumn} key={id} {...props} />;
    case "ContentfulLandingPageSection2Column1Image":
      return <LpTwoColSection className={className?.twoColumn} key={id} {...props} />;
    case "ContentfulLandingPageSection3Column3Images":
      return <LpThreeColSection className={className?.threeColumn} key={id} {...props} />;
    case "ContentfulLandingPageSectionBlockquote":
      return <LpBlockquoteSection className={className?.blockquote} key={id} {...props} />;
    case "ContentfulLandingPageSectionCarousel":
      return <CarouselLarge className={className?.carousel} key={id} {...props} />;
    default:
      return null;
  }
};

export const getActionSectionsComponent = ({ id, __typename, className, ...props }) => {
  switch (__typename) {
    case "ContentfulLandingPageSectionFooterCta":
      return <CTASection className={className?.ctaSection} key={id} {...props} />;
    case "ContentfulLandingPageSectionEmailCapture":
      return <EmailMarketingSection className={className?.emailMarketing} key={id} {...props} />;
    case "ContentfulGenericList": {
      return props.listItems?.[0]?.__typename === "ContentfulListItemFaq" ? (
        <LpFaqSection className={className?.faqSection} key={id} items={props.listItems} {...props} />
      ) : null;
    }
    case "ContentfulExploreMangomint": {
      return <ExploreMangomint className={className?.exploreMangomint} key={id} {...props} />;
    }
    case "ContentfulLandingPageSectionLogoSoup":
      return <LpLogoSoupSection className={className?.logoSoup} key={id} {...props} />;
    default:
      return null;
  }
};

export const getLandingPageSections = ({ sections, actionSections, className }) => {
  const sectionComponents = sections?.length
    ? sections.map((props) => getSectionComponent({ ...props, className }))
    : [];

  const actionSectionsComponents = actionSections?.length
    ? actionSections.map((props) => getActionSectionsComponent({ ...props, className }))
    : [];

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useSlideEnterAnimation({ dependencies: [sectionComponents] });

  return {
    sectionComponents,
    actionSectionsComponents,
  };
};
